export default __webpack_public_path__ + "static/media/wanna1.1bb1bac5.webp";